export default __webpack_public_path__ + "static/media/cake.8d6424ed.svg";